import { render } from "./VersionDetail.vue?vue&type=template&id=5a40e296"
import script from "./VersionDetail.vue?vue&type=script&lang=js"
export * from "./VersionDetail.vue?vue&type=script&lang=js"
script.render = render

export default script